module.exports = __webpack_public_path__ + "fonts/junction-bold.97ff1506.ttf";